// Lazy-load supabase to keep it out of the critical JS bundle
let _supabasePromise: Promise<typeof import('@/integrations/supabase/client')> | null = null;
function getSupabase() {
  if (!_supabasePromise) {
    _supabasePromise = import('@/integrations/supabase/client');
  }
  return _supabasePromise;
}

// ── In-memory cache (hydrated from localStorage synchronously, then DB in background) ─────────────

let _cache: Record<string, unknown> = {};
let _initialized = false;

export function loadJSON<T>(key: string): T | null {
  if (_initialized && key in _cache) return _cache[key] as T;
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveLocal(key: string, data: unknown): void {
  localStorage.setItem(key, JSON.stringify(data));
  _cache[key] = data;
}

export async function saveToDb(key: string, data: unknown): Promise<void> {
  try {
    const { supabase } = await getSupabase();
    const { error } = await supabase
      .from('game_settings')
      .upsert({ id: key, data: data as any, updated_at: new Date().toISOString() }, { onConflict: 'id' });
    if (error) console.error('Failed to save setting to DB:', error);
  } catch (e) {
    console.error('DB save error:', e);
  }
}

/**
 * Initialize cache. Marks as initialized immediately (using localStorage
 * values already available via loadJSON) and fetches DB rows in the
 * background so the app can render without waiting for the network.
 */
export function initCache(): void {
  if (_initialized) return;
  _initialized = true;

  // Fire-and-forget: pull latest from DB and update cache + localStorage
  getSupabase().then(({ supabase }) => {
    supabase
      .from('game_settings')
      .select('id, data')
      .then(({ data, error }) => {
        if (!error && data) {
          for (const row of data) {
            _cache[row.id] = row.data;
            localStorage.setItem(row.id, JSON.stringify(row.data));
          }
        }
      });
  });
}

export function clearCache(): void {
  _cache = {};
}
